import {
  Box,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import auth from "../Layout/util/auth";
import homeStyle from "./styles";
import moment from "moment";
import songStyle from "../SongDetail/styles";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../src/constant/appConstants";
import { songPageGTMCTAClick } from "../../util/gtmutil";

const FeaturedSongs = ({ data, featureSong }) => {
  const heading = data.get("upcomingsongsheading");
  const r = auth();
  const [days, setDays] = useState(0);
  const [minutes, setMinutess] = useState(0);
  const [hours, setHours] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [date, setDate] = useState();
  const [data1, setData] = useState();
  const [featuredSongsno, setFeaturedSongsno] = useState(6);
  const [timeDiff1, setTimeDiff1] = useState(false);
  const router = useRouter();
  console.log(
    featureSong?.sort(
      (a, b) => b?.attributes?.sequence - a?.attributes?.sequence
    )
  );
  const [featureSongvalue, setFeatureSongvalue] = useState(featureSong);

  const handleMoredetails = (data, type = "Image") => {
    songPageGTMCTAClick(
      r,
      type,
      "featured drops",
      type,
      "loggedIn",
      "Guest",
      data?.attributes?.Title
    );
    router.push(data?.attributes?.nft_slug);
  };

  if (typeof window !== "undefined") {
    localStorage.setItem("songId", data1?.id);
  }
  const countDown = () => {
    const today = new Date().getTime();
    const endDate = new Date(date).getTime();
    const timeDiff = endDate - today;
    const s = 1000;
    const m = s * 60;
    const h = m * 60;
    const d = h * 24;

    var timeDays = Math.floor(timeDiff / d);
    var timeHours = Math.floor((timeDiff % d) / h);
    var timeMinutes = Math.floor((timeDiff % h) / m);
    var timeSeconds = Math.floor((timeDiff % m) / s);
    setDays(timeDays);
    setHours(timeHours);
    setMinutess(timeMinutes);
    setSeconds(timeSeconds);
    setTimeDiff1(timeDiff);
  };

  useEffect(() => {
    // remove the below if to get dropping in
    if (timeDiff1 > 0) {
      countDown();
      if (!timeDiff1) {
        setTimeDiff1(true);
      }
    }
  }, [timeDiff1]);
  const { country_code } = useSelector((state) => state.layout);
  return (
    <Box sx={homeStyle.featuredSongsSection}>
      <Box sx={homeStyle.featuredTitleH1}>
        <Typography variant="h1" sx={homeStyle.featuredTitleH1}>
          {/* {heading} */}
          Featured Drops
        </Typography>
      </Box>
      {featureSongvalue.length > 0 && featuredSongsno <= 1 ? (
        <Box sx={homeStyle.featuredRow}>
          <Box sx={homeStyle.featuredBoxSingle}>
            <Box sx={homeStyle.featuredCardImageBoxSingle}>
              <Link href={featureSongvalue?.[0]?.attributes?.nft_slug}>
                {" "}
                <Box
                  component="img"
                  src={data1?.attributes?.image_url}
                  alt=""
                ></Box>{" "}
              </Link>
            </Box>
            <Box sx={homeStyle.featuredCardContentSingle}>
              <Box sx={homeStyle.featuredSingleTitle}>
                <Typography component="p" sx={homeStyle.songDate}>
                  {moment(featureSongvalue?.[0]?.attributes?.lauch_date).format(
                    "MMM DD, YYYY"
                  )}
                </Typography>
                <Box sx={homeStyle.songNameContent}>
                  <Typography component="p">
                    <Link
                      href={featureSongvalue?.[0]?.attributes?.nft_slug}
                      sx={homeStyle.songName}
                    >
                      {data1?.attributes?.Title}
                    </Link>
                  </Typography>
                  <Link
                    href={`/artist/${data1?.attributes?.artists?.data[0]?.attributes?.slug}`}
                    sx={homeStyle.songName}
                  >
                    <Typography component="p" sx={homeStyle.singerName}>
                      <Box
                        component="img"
                        src={`${
                          data1?.attributes?.artists?.data[0]?.attributes
                            ?.image_thumbnail
                            ? data1?.attributes?.artists?.data[0]?.attributes
                                ?.image_thumbnail
                            : "/images/nft/artist.png"
                        }`}
                      />
                      <Typography component="small">{`${data1?.attributes?.artists?.data[0]?.attributes?.name}`}</Typography>
                    </Typography>
                  </Link>
                </Box>
              </Box>
              <Box sx={homeStyle.songDetails}>
                <Typography component="p" sx={homeStyle.songDescription}>
                  {data1?.attributes?.Description}
                </Typography>
                {timeDiff1 >= 1 ? (
                  <>
                    <Typography style={{ marginTop: "40px" }} variant="span">
                      Dropping in
                    </Typography>
                    <Box sx={homeStyle.countDown}>
                      <Table sx={homeStyle.tableCount}>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ color: "#fff" }} align="center">
                              <Typography variant="h4">{days}</Typography>
                              <Typography component="small">Days</Typography>
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }} align="center">
                              <Typography variant="h4">{hours}</Typography>
                              <Typography component="small">Hours</Typography>
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }} align="center">
                              <Typography variant="h4">{minutes}</Typography>
                              <Typography component="small">Min</Typography>
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }} align="center">
                              <Typography variant="h4">{seconds}</Typography>
                              <Typography component="small">Sec</Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                    <Typography
                      component="small"
                      sx={homeStyle.counterLine}
                    ></Typography>
                    <Box sx={homeStyle.featuredStats}>
                      <Box
                        sx={homeStyle.featuredLowestAsk}
                        style={{ marginTop: "40px" }}
                      >
                        <Typography
                          component="small"
                          sx={homeStyle.featuredCardSubTitle}
                        >
                          Price Range
                        </Typography>
                        {country_code == "IN" && (
                          <Typography
                            variant="h3"
                            sx={homeStyle.featuredCardTitle}
                          >
                            {" "}
                            ₹
                            {Math.round(
                              featureSongvalue?.[0].attributes.lowest_ask * 80
                            )}{" "}
                            ₹
                            {Math.round(
                              featureSongvalue?.[0].attributes.highest_ask * 80
                            )}
                          </Typography>
                        )}
                        {country_code == "OTHER" && (
                          <Typography
                            variant="h3"
                            sx={homeStyle.featuredCardTitle}
                          >
                            {" "}
                            ${featureSongvalue?.[0].attributes.lowest_ask} - $
                            {featureSongvalue?.[0].attributes.highest_ask}
                          </Typography>
                        )}
                      </Box>
                      {/* <Box sx={homeStyle.featuredTokens}>
                        <Typography
                          component="small"
                          sx={homeStyle.featuredCardSubTitle} 
                        >
                          Royalty Share
                        </Typography>
                        <Typography
                          variant="h3"
                          sx={homeStyle.featuredCardTitle}
                        >
                          {featureSongvalue?[0].attributes?.lowest_ask}
                        </Typography>
                      </Box> */}
                    </Box>
                    <Box sx={homeStyle.buttonSet} style={{ marginTop: "30px" }}>
                      {/* <Button
                        variant="outlined"
                        sx={homeStyle.featuredBuyOnMarketPlace}
                        onClick={()=> handleMoredetails()}
                      >
                        More Details
                      </Button> */}
                      <Button
                        variant="contained"
                        sx={homeStyle.featuredBuyNow}
                        onClick={() =>
                          handleMoredetails(
                            featureSongvalue?.[0],
                            "More Details"
                          )
                        }
                      >
                        More Details
                        {/* Reserve Now */}
                      </Button>
                      {/* <RegisterNow></RegisterNow> */}
                    </Box>
                  </>
                ) : (
                  <>
                    <Box sx={homeStyle.featuredStats}>
                      <Box sx={homeStyle.featuredLowestAsk}>
                        <Typography
                          component="small"
                          sx={homeStyle.featuredCardSubTitle}
                        >
                          Price Range
                        </Typography>
                        {country_code == "IN" && (
                          <Typography
                            variant="h3"
                            sx={homeStyle.featuredCardTitle}
                          >
                            {" "}
                            ₹
                            {Math.round(
                              featureSongvalue?.[0].attributes.lowest_ask * 80
                            )}{" "}
                            - ₹
                            {Math.round(
                              featureSongvalue?.[0].attributes.highest_ask * 80
                            )}
                          </Typography>
                        )}
                        {country_code == "OTHER" && (
                          <Typography
                            variant="h3"
                            sx={homeStyle.featuredCardTitle}
                          >
                            {" "}
                            ${featureSongvalue?.[0].attributes.lowest_ask} - $
                            {featureSongvalue?.[0].attributes.highest_ask}
                          </Typography>
                        )}
                      </Box>
                      {/* <Box sx={homeStyle.featuredTokens}>
                        <Typography
                          component="small"
                          sx={homeStyle.featuredCardSubTitle}
                        >
                          Lowest Price
                        </Typography>
                        <Typography
                          variant="h3"
                          sx={homeStyle.featuredCardTitle}
                        >
                          ${lowestprice}
                        </Typography>
                      </Box> */}
                    </Box>
                    <Box sx={homeStyle.buttonSet}>
                      {/* <Button
                        variant="outlined"
                        sx={homeStyle.featuredBuyOnMarketPlace}
                        onClick={handleMoredetails}
                      >
                        More Details
                      </Button> */}
                      <Button
                        variant="contained"
                        sx={homeStyle.featuredBuyNow}
                        onClick={() =>
                          handleMoredetails(
                            featureSongvalue?.[0],
                            "More Details"
                          )
                        }
                      >
                        More Details
                        {/* Buy Now */}
                      </Button>
                      {/* <RegisterNow></RegisterNow> */}
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={homeStyle.featuredRow}>
          {/* =====Card Box 1===== */}

          <Box sx={homeStyle.featuredSongsBox}>
            {featureSongvalue.length > 0 &&
              featureSongvalue?.map((data) => {
                return (
                  <Box key={data?.id} sx={homeStyle.featuredBox}>
                    <Box sx={homeStyle.featuredCard}>
                      <Box sx={homeStyle.featuredCardImageBox}>
                        <Link onClick={() => handleMoredetails(data, "Image")}>
                          <Box
                            sx={homeStyle.featuredCardImage}
                            component="img"
                            src={
                              data?.attributes.additional_media_image.data[0]
                                .attributes.formats.small.url
                            } //Card Thumbnails, to set to small size
                            alt=""
                          />
                        </Link>
                        {/* <Link
                        herf={
                          data?.attributes?.FullAudio?.data?.attributes?.url
                        }
                        sx={homeStyle.featuredPlayIcon}
                      >
                        <Box
                          component="img"
                          src="./images/featured/play-icon.png"
                          width="100%"
                        />
                      </Link> */}
                      </Box>
                      <Box sx={homeStyle.featuredCardContent}>
                        <Typography
                          variant="h1"
                          sx={homeStyle.featuredCardTitle}
                        >
                          {" "}
                          <Link
                            href={data?.attributes?.nft_slug}
                            sx={homeStyle.songName}
                          >
                            {data?.attributes?.Title}
                          </Link>
                        </Typography>

                        <Link
                          href={`/artist/${data?.attributes?.artists?.data[0]?.attributes?.slug}`}
                          sx={homeStyle.songName}
                        >
                          <Typography component="p" sx={homeStyle.singerName}>
                            <Box
                              // Smallest Thumbnail
                              component="img"
                              src={`${
                                data?.attributes.artists.data[0].attributes
                                  .image_thumbnail
                                  ? data.attributes.artists.data[0].attributes
                                      .image_thumbnail
                                  : "/images/nft/artist.png"
                              }`}
                            />
                            <Typography component="small">{`${data?.attributes?.artists?.data[0]?.attributes?.name}`}</Typography>
                          </Typography>
                        </Link>

                        {/* <Typography
                        variant="small"
                        sx={homeStyle.featuredCardSubTitle}
                      >
                        {data?.attributes?.ytube_views} Views on YouTube
                      </Typography> */}

                        <Box sx={homeStyle.featuredStats}>
                          {data?.attributes?.is_tradable ? (
                            <Box sx={homeStyle.featuredLowestAsk}>
                              <Typography
                                component="small"
                                sx={homeStyle.featuredCardSubTitle}
                              >
                                Current Price
                              </Typography>
                              <Typography
                                variant="h3"
                                sx={homeStyle.featuredCardTitle}
                              >
                                {country_code == "IN" && (
                                  <Typography
                                    variant="h3"
                                    sx={homeStyle.featuredCardTitle}
                                  >
                                    ₹
                                    {Math.round(
                                      data?.attributes.tradingPrice * 80
                                    )}{" "}
                                  </Typography>
                                )}
                                {country_code == "OTHER" && (
                                  <Typography
                                    variant="h3"
                                    sx={homeStyle.featuredCardTitle}
                                  >
                                    {" "}
                                    ${data?.attributes.tradingPrice}
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                          ) : (
                            <Box sx={homeStyle.featuredLowestAsk}>
                              <Typography
                                component="small"
                                sx={homeStyle.featuredCardSubTitle}
                              >
                                Price Range
                              </Typography>

                              {data?.attributes?.ticketing_nft_lowest_price ? (
                                <Typography
                                  variant="h3"
                                  sx={homeStyle.featuredCardTitle}
                                >
                                  {country_code == "IN" && (
                                    <Typography
                                      variant="h3"
                                      sx={homeStyle.featuredCardTitle}
                                    >
                                      ₹
                                      {Math.round(
                                        data?.attributes
                                          .ticketing_nft_lowest_price * 80
                                      )}{" "}
                                      - ₹
                                      {Math.round(
                                        data?.attributes
                                          .ticketing_nft_highest_price * 80
                                      )}
                                    </Typography>
                                  )}
                                  {country_code == "OTHER" && (
                                    <Typography
                                      variant="h3"
                                      sx={homeStyle.featuredCardTitle}
                                    >
                                      {" "}
                                      $
                                      {
                                        data?.attributes
                                          .ticketing_nft_lowest_price
                                      }{" "}
                                      - $
                                      {
                                        data?.attributes
                                          .ticketing_nft_highest_price
                                      }
                                    </Typography>
                                  )}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="h3"
                                  sx={homeStyle.featuredCardTitle}
                                >
                                  {country_code == "IN" && (
                                    <Typography
                                      variant="h3"
                                      sx={homeStyle.featuredCardTitle}
                                    >
                                      ₹
                                      {Math.round(
                                        data?.attributes.lowest_ask * 80
                                      )}{" "}
                                      - ₹
                                      {Math.round(
                                        data?.attributes.highest_ask * 80
                                      )}
                                    </Typography>
                                  )}
                                  {country_code == "OTHER" && (
                                    <Typography
                                      variant="h3"
                                      sx={homeStyle.featuredCardTitle}
                                    >
                                      {" "}
                                      ${data?.attributes.lowest_ask} - $
                                      {data?.attributes.highest_ask}
                                    </Typography>
                                  )}
                                </Typography>
                              )}
                            </Box>
                          )}
                          {/* <Box sx={homeStyle.featuredTokens}>
                          <Typography
                            component="small"
                            sx={homeStyle.featuredCardSubTitle}
                          >
                            Available Tokens
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={homeStyle.featuredCardTitle}
                          >
                            {data?.attributes.available_token} /{" "}
                            {data?.attributes.total_tokens}
                          </Typography>
                        </Box> */}
                        </Box>
                        {/* <Button variant="contained" sx={homeStyle.featuredBuyNow}>Buy Now</Button> */}
                        {/* <Button
                        variant="outlined"
                        sx={homeStyle.featuredBuyOnMarketPlace}
                        onClick={() => {
                          router.push(`${data.attributes.nft_slug}`);
                        }}
                      >
                        More Details
                      </Button> */}

                        {/* <RegisterNow></RegisterNow> */}
                        {/* <Box sx={homeStyle.buttonSet}>
                          <Button variant="contained" sx={homeStyle.featuredBuyNow} onClick={()=>{handleMoredetails(data)}}>
                            Reserve Now
                          </Button>

                      </Box> */}
                        {/* <Typography
                        component="small"
                        sx={homeStyle.featuredBottomText}
                      >
                        Listen Full Song on{" "}
                        <Box
                          component="img"
                          src="./images/featured/spotify.png"
                          width="90"
                          sx={homeStyle.spotifyLogo}
                        />
                      </Typography> */}
                        <Button
                          variant="contained"
                          sx={homeStyle.featuredBuyNow1}
                          onClick={() => {
                            handleMoredetails(data, "More Details");
                          }}
                        >
                          More Details
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
          </Box>

          {/* =====Card Box 2===== */}

          {/* <Box sx={homeStyle.featuredBox}>
               <Box sx={homeStyle.featuredCard}>
                  <Box sx={homeStyle.featuredCardImageBox}>
                     <Box sx={homeStyle.featuredCardImage} component="img" src="./images/featured/guru2.jpg" alt="" />
                     <Link herf="#" sx={homeStyle.featuredPlayIcon}><Box component="img" src="./images/featured/play-icon.png" width="100%" /></Link>
                  </Box>
                  <Box sx={homeStyle.featuredCardContent}>
                     <Typography variant="h1" sx={homeStyle.featuredCardTitle}>Dance Meri Rani</Typography>
                     <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>50M+ Views on YouTube</Typography>
                     <Box sx={homeStyle.featuredStats}>
                        <Box sx={homeStyle.featuredLowestAsk}>
                           <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>Lowest Ask</Typography>
                           <Typography variant="h3" sx={homeStyle.featuredCardTitle}>2.21</Typography>
                        </Box>
                        <Box sx={homeStyle.featuredTokens}>
                           <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>Available Tokens</Typography>
                           <Typography variant="h3" sx={homeStyle.featuredCardTitle}>99 / 220</Typography>
                        </Box>
                     </Box>
                     <Button variant="outlined" sx={homeStyle.featuredBuyOnMarketPlace}>Buy On Marketplace</Button>
                     <Typography variant="small" sx={homeStyle.featuredBottomText}>
                        Listen Full Song on <Box component="img" src="./images/featured/spotify.png" width="90" sx={homeStyle.spotifyLogo} />
                     </Typography>
                  </Box>
               </Box>
            </Box> */}

          {/* =====Card Box 3===== */}

          {/* <Box sx={homeStyle.featuredBox}>
               <Box sx={homeStyle.featuredCard}>
                  <Box sx={homeStyle.featuredCardImageBox}>
                     <Box sx={homeStyle.featuredCardImage} component="img" src="./images/featured/guru3.jpg" alt="" />
                     <Link herf="#" sx={homeStyle.featuredPlayIcon}><Box component="img" src="./images/featured/play-icon.png" width="100%" /></Link>
                  </Box>
                  <Box sx={homeStyle.featuredCardContent}>
                     <Typography variant="h1" sx={homeStyle.featuredCardTitle}>Dance Meri Rani</Typography>
                     <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>50M+ Views on YouTube</Typography>
                     <Box sx={homeStyle.featuredStats}>
                        <Box sx={homeStyle.featuredLowestAsk}>
                           <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>Lowest Ask</Typography>
                           <Typography variant="h3" sx={homeStyle.featuredCardTitle}>2.21</Typography>
                        </Box>
                        <Box sx={homeStyle.featuredTokens}>
                           <Typography variant="small" sx={homeStyle.featuredCardSubTitle}>Available Tokens</Typography>
                           <Typography variant="h3" sx={homeStyle.featuredCardTitle}>99 / 220</Typography>
                        </Box>
                     </Box>
                     <Button variant="contained" disabled sx={homeStyle.featuredBtnDisabled}>Sold Out</Button>
                     <Typography variant="small" sx={homeStyle.featuredBottomText}>
                        Listen Full Song on <Box component="img" src="./images/featured/spotify.png" width="90" sx={homeStyle.spotifyLogo} />
                     </Typography>
                  </Box>
               </Box>
            </Box> */}
        </Box>
      )}
    </Box>
  );
};
export default FeaturedSongs;
